var app_advertisers_table = $('#app-advertisers-dash-table');

if (app_advertisers_table.length) {
    function initializeAdvertisersTable(reload, range = "") {
        window.app_advertisers_table
            .DataTable({
                "processing": true,
                "serverSide": true,
                "searching": false,
                "info": false,
                "bFilter": false,
                "bInfo": false,
                "lengthChange": false,
                "scrollY": "245px",
                "scrollCollapse": true,
                ajax: {
                    url: '/advertisers/dash?range=' + range,
                    dataSrc: 'data'
                },
                order: [ [3, "desc"] ],
                columns: [
                    {data: 'name'},
                    {data: 'campaigns'},
                    {data: 'agency_commission'},
                    {data: 'created_at'}
                ],
                destroy: true,
                "columnDefs": [
                    {
                        "targets": 0,
                        "orderable": true,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html(cellData.replace("'>", "'><i class=\"fa fa-external-link\"></i> "));
                        }
                    },
                    {
                        "targets": 1,
                        "orderable": false,
                    },
                    {
                        "targets": 2,
                        "orderable": false,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            $(td).html(cellData + ' %');
                        }
                    },{
                        "targets": 3,
                        "orderable": true,
                        "createdCell": function (td, cellData, rowData, row, col) {
                            var date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                            $(td).html('<i class="fa fa-clock-o"></i> ' + date.format("MMM. D, YYYY"));
                        }
                    }]
            });

        /*$.ajax({
            url: '/advertisers/updateleftmenu',
            success: function (data) {
                console.log($("#left_menu_advertisers").html());
                $("#left_menu_advertisers").html(data['advertisers']);
                console.log($("#left_menu_advertisers").html());
            },
            error: function(xhr) {
                console.log(xhr);
                ajax_error();
                debug(xhr.responseText);
            }
        });*/
        if(reload)
            location.reload();
    }

    function deleteAdvertiser(urlVar) {
        swal({
                title: "Warning",
                text: "Are you sure you want to delete?",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn-danger",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true,
                closeOnCancel: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    show_loader();
                    $.ajax({
                        url: urlVar,
                        success: function (response) {
                            global_notification('success', 'Advertiser deleted');
                            initializeAdvertisersTable(true);
                            hide_loader();
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                global_notification('warning', xhr.responseJSON.message);
                            } else {
                                ajax_error();
                                debug(xhr.responseText);
                            }
                            hide_loader();
                        }
                    });
                }
            });

    }

    //initializeAdvertisersTable(false);
}